import { PrimeIcons } from "primereact/api";
import { Avatar } from "primereact/avatar";
import { Button } from "primereact/button";
import { Divider } from "primereact/divider";
import { Menu } from "primereact/menu";
import { useRef } from "react";

import { labelResendEmail, labelRimuovi } from "_constants";
import { User } from "interfaces";

export const DetailPanelUserRow = ({
  user,
  deleteCallback,
  shareCallback,
  showAction,
}: {
  user: User;
  deleteCallback: Function;
  shareCallback: Function;
  showAction: boolean;
}) => {
  const menuRight = useRef<any>(null);
  const items = [
    ...(!user.accepted
      ? [
          {
            label: labelResendEmail,
            icon: PrimeIcons.ENVELOPE,
            command: () => {
              shareCallback(user);
            },
          },
        ]
      : []),
    {
      label: labelRimuovi,
      icon: PrimeIcons.USER_MINUS,
      className: "delete-color",
      command: () => {
        deleteCallback(user);
      },
    },
  ];

  return (
    <>
      <div className="flex-container align-center gap-8 padd-left-14 padd-rigth-14">
        <Avatar
          label={`${user.name.charAt(0).toUpperCase()}${user.lastName
            .charAt(0)
            .toUpperCase()}`}
          size="large"
          shape="square"
          className={`${!user.accepted ? "waiting-acceptance" : ""}`}
        />
        <div>
          <div>
            <span className="text-base-bold capitalize d-iblock">
              {user.name}&nbsp;
            </span>
            <span className="text-base-bold capitalize d-iblock">
              {user.lastName}
            </span>
          </div>
          <span className="text-base-regular">{user.email}</span>
        </div>
        {showAction && (
          <div className="flex-container justify-end flex-1">
            <Menu
              model={items}
              popup
              ref={menuRight}
              id="popup_menu_right"
              className="p-menu-custom-logout"
              popupAlignment="right"
            />
            <Button
              icon={PrimeIcons.ELLIPSIS_V}
              text
              severity="secondary"
              onClick={(event) => menuRight?.current?.toggle(event)}
            />
          </div>
        )}
      </div>
      <Divider className="grey margin-top-14 margin-bottom-14" />
    </>
  );
};
